import { flex } from "@styled-system/patterns";

export const wrapperClass = flex({
	width: "full",
	justifyContent: "space-between",
});
